import { Popup } from "./class";

// Initialize mobile menu
if (document.querySelector("#mobile-menu")) {
  const mobileMenuElement = document.querySelector("#mobile-menu");
  
  new Popup("#mobile-menu", {
    openButtons: ".header__burger",
    closeButton: ".mobile-menu__close",
    closeOnResize: true,
    on: {
      open: () => {
        document.body.style.overflow = "hidden";
        
        const burger = document.querySelector('.header__burger');
        if (burger) {
          burger.setAttribute('aria-expanded', 'true');
        }
      },
      close: () => {
        document.body.style.overflow = "";
        
        const burger = document.querySelector('.header__burger');
        if (burger) {
          burger.setAttribute('aria-expanded', 'false');
        }

        // Close all submenus when menu closes
        closeAllSubmenus();
      },
    },
  });

  // Use event delegation for submenu toggles
  const mobileNav = mobileMenuElement.querySelector('.mobile-menu__nav');
  
  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      // Check if clicked element is a link inside menu-item-has-children
      const link = e.target.closest('.menu-item-has-children > a');
      
      if (link) {
        e.preventDefault();
        
        const parentItem = link.parentElement;
        const subMenu = parentItem.querySelector('.sub-menu');
        
        if (subMenu) {
          toggleSubmenu(parentItem, subMenu);
        }
      }
    });
  }
}

function toggleSubmenu(item, subMenu) {
  const isOpen = item.classList.contains('is-open');

  if (isOpen) {
    // Close with animation
    subMenu.style.maxHeight = '0';
    subMenu.style.opacity = '0';
    subMenu.style.marginTop = '0';
    item.classList.remove('is-open');
    item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
  } else {
    // Close other open submenus first
    closeAllSubmenus();
    
    // Open this one with animation
    item.classList.add('is-open');
    item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'true');
    subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
    subMenu.style.opacity = '1';
    subMenu.style.marginTop = '0.25rem';
  }
}

function closeAllSubmenus() {
  const allSubmenus = document.querySelectorAll('.mobile-menu__nav .sub-menu');
  const allItems = document.querySelectorAll('.mobile-menu__nav .menu-item-has-children');

  allSubmenus.forEach(submenu => {
    submenu.style.maxHeight = '0';
    submenu.style.opacity = '0';
    submenu.style.marginTop = '0';
  });

  allItems.forEach(item => {
    item.classList.remove('is-open');
    item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
  });
}
